<template>
    <div class="spinner-wrapper">
        <ProgressSpinner class="spinner-content" strokeWidth="8" />
        {{ t('global.loading') }}
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n({ useScope: 'global' });
</script>

<style scoped>
.spinner-wrapper {
    @apply w-full h-full flex justify-center items-center flex-col gap-2;
}
.spinner-content {
    @apply h-8 w-8;
}
</style>
